const AGGREGATION_TYPE = {
	SUM: 'sum',
	AVERAGE: 'average',
	LAST_VALUE: 'last-value',
	PERCENTAGE_YES: 'percentage-yes',
	NUMBER_OF_YESES: 'number-of-yeses',
	USE_EQUATION: 'use-equation',
	LIST_UNIQUE_VALUES: 'list-unique-values',
	MEDIAN: 'median',
	GEOMETRIC_MEAN: 'geometric-mean',
	PERCENTAGE: 'percentage',
	MINIMUM: 'minimum',
	MAXIMUM: 'maximum',
	MIN_DATE: 'min-date',
	MAX_DATE: 'max-date',
	MIN_TIME: 'min-time',
	MAX_TIME: 'max-time',
	NONE: 'none',
	UNIQUE: 'unique',
	COUNT: 'count',
	PERCENTAGE_REACHING_GOAL: 'percentage-reaching-goal',
	NUMBER_REACHING_GOAL: 'number-reaching-goal'
}

export default AGGREGATION_TYPE
export const {
	SUM,
	AVERAGE,
	LAST_VALUE,
	PERCENTAGE_YES,
	NUMBER_OF_YESES,
	USE_EQUATION,
	LIST_UNIQUE_VALUES,
	MEDIAN,
	GEOMETRIC_MEAN,
	PERCENTAGE,
	MINIMUM,
	MAXIMUM,
	MIN_DATE,
	MAX_DATE,
	MIN_TIME,
	MAX_TIME,
	NONE,
	UNIQUE,
	COUNT,
	PERCENTAGE_REACHING_GOAL,
	NUMBER_REACHING_GOAL
} = AGGREGATION_TYPE
AGGREGATION_TYPE.__filename__ = 'datasets/model/aggregation-type.js'
